import React, { useEffect } from 'react'
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Link } from 'react-router-dom'
import { MdNavigateNext } from 'react-icons/md'
import { Button, Grid, InputLabel, MenuItem, Select, Table, TableBody, TableCell, TableHead, TableRow, TextField, } from '@mui/material';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { AccessLevel, AccessTeam, subAdmin, useStyles } from '../../constant/constant.js';
import { useDispatch, useSelector } from 'react-redux';
import { addUserState, editsubAdmin,stateRefresh } from '../../slices/user.js';
import axios from 'axios';
import Swal from 'sweetalert2';
import { isEmpty } from 'lodash';
import moment from 'moment'
import { USER } from '../../constant/endpoint.js';
import MultiSelector from '../../components/multiSelector/customMultiSelector.js';
import { Row } from 'simple-flexbox';
import styled from 'styled-components';
import { axiosRequest } from '../../utility/axios.js';
import { Breadcrumb } from 'reactstrap';

export const Heading = styled.div`
    font-size: ${props => props.fontSize || "18px"};
    font-weight: ${props => props.fontWeight || "500"};
    text-align: ${props => props.textAlign || "left"};
    color: ${props => props.color || "#000000"};
    padding: ${props => props.padding || "0px"};
    margin: ${props => props.margin};

    @media(max-width:680px) { font-size: ${props => props.mdFontSize}; }
    @media(max-width:550px) { font-size: ${props => props.smFontSize}; }
    @media(max-width:425px) { font-size: ${props => props.xsFontSize}; }
`;
export const MainBox = styled.div`
margin: 20px;
padding: 10px 50px 30px;
border: 2px solid #f0f3f5;
background-color: white;
border-radius: 10px;
`;

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    height: '65%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    padding: '0px 30px',
    overflow: "auto",
    paddingBottom: "20px"
};


const SubAdmin = () => {
    const [open, setOpen] = React.useState(false);
    const [users, setUsers] = React.useState([]);
    const userAdmin = useSelector(state => state.userSlice)
    const login = useSelector(state => state.loginSlice)
    const dispatch = useDispatch()
    const classes = useStyles();
    const breadcrumbs = [
        <Link underline="hover" key="1" color="inherit" to={''} >
            <h4>Sub Admin</h4>
        </Link>, <h5>List</h5>
    ];
    const handleClose = () => setOpen(false);
    const handleOpen = () => {
        setOpen(true)
        dispatch(stateRefresh())
    };

    const handleField = (e) => {
        
        dispatch(addUserState({ name: e.target.name, value: e.target.value }))
    }
    const getSweetAlert = (type, topic) => {
        Swal.fire({
            position: 'top-end',
            icon: type,
            title: topic,
            showConfirmButton: false,
            timer: 3000
        })
    }
    const isValidation = () => {
        var status = true
        if (isEmpty(userAdmin.userState.name)) {
            getSweetAlert('error', 'Fill the name field')
            return status = false
        }
        if (isEmpty(userAdmin.userState.email)) {
            getSweetAlert('error', 'Fill the Email field')
            return status = false
        }
        // if (isEmpty(userAdmin.userState.password)) {
        //     getSweetAlert('error', 'Fill the Password field')
        //     if(userAdmin.userState.isEdit){
        //         return status
        //     }else{
        //         return status = false
        //     }
        // }
        // if ((userAdmin.userState.password.length <= 5)) {
        //     getSweetAlert('error', 'Password should be at least 6 characters')
        //     return status = false
        // }
        if (userAdmin.userState.access_level.length > 0) {
            getSweetAlert('error', 'Fill the Access Level field')
            return status = false
        }
        return status = true
    }
    const handleSubmit = async () => {
        if (!isValidation()) {
            return; // Stop execution if validation fails
        }
    
        try {
            let response;
    
            // Check if editing an existing user
            if (userAdmin.userState.isEdit) {
                // Handle password edge case
                if (userAdmin.userState.password?.trim() === "") {
                    delete userAdmin.userState.password; // Remove empty password field
                }
    
                // Send PATCH request to update user
                response = await axiosRequest(
                    "PATCH",
                    USER.replace(':user_id', userAdmin.userState._id),
                    '',
                    userAdmin.userState
                );
    
                if (response?.status === 'success') {
                    Swal.fire(`${userAdmin.userState.name} Edited Successfully`);
                    setOpen(false); // Close modal
                    fetchUserList(); // Refresh user list
                }
            } else {
                
                // Send POST request to create a new user
                response = await axiosRequest(
                    "POST",
                    USER.replace(':user_id', ''),
                    '',
                    userAdmin.userState
                );
    
                if (response?.status === 'success') {
                    Swal.fire('New Admin Added Successfully');
                    setOpen(false); // Close modal
                    fetchUserList(); // Refresh user list
                }
            }
        } catch (error) {
            console.error("Error submitting user data:", error);
            Swal.fire('Error', 'An error occurred while processing your request.', 'error');
        }
    };
    
    useEffect(() => {
        fetchUserList()
    }, [])

    const fetchUserList = async () => {
        const response = await axiosRequest("GET",USER.replace(':user_id',''), '','', {
                headers: {
                    'auth_token': `${login.token}`,
                }
            })

        // const response = await axios.get(USER.replace(':user_id',''), {
        //     headers: {
        //         'auth_token': `${login.token}`,
        //     }
        // })
        if (response?.status === 'success') {
            setUsers(response?.data)
        }
    }
    const updateHandle = (data) => {
        setOpen(true)
        const adminData = {
            ...data,
            isEdit:true
        }
        dispatch(editsubAdmin(adminData))
    } 

    const Breadcrumbs = () => {
        return (
        <Breadcrumb>
          <Link to="/sub-admin" style={{color: "#007bff"}}>
            <h3>Sub Admin</h3>
          </Link>
        </Breadcrumb>
        )
    }
       
    return (
        <>
            <div className="homeCard">
                <div className='subHomeCard'>
                    <Row justifyContent='space-between'>
                    <Breadcrumbs></Breadcrumbs>
                    <Button variant={'contained'} color={'primary'} style={{ float: "right" , marginBottom:"30px"}} onClick={handleOpen}>Add SubAdmin</Button>
                    </Row>
                    
                    <Box>
                        <Table className={classes.table} >
                            <TableHead>
                                <TableCell align="center">Id</TableCell>
                                <TableCell align="center">Email</TableCell>
                                <TableCell align="center">Name</TableCell>
                                <TableCell align="center">Status</TableCell>
                                <TableCell align="center">Access Level</TableCell>
                                <TableCell align="center">Registered At</TableCell>
                                <TableCell align="center">Actions</TableCell>
                            </TableHead>
                            <TableBody>
                                {
                                    users?.map((data,index) =>
                                        <TableRow>
                                            <TableCell align="center">{index+1}</TableCell>
                                            <TableCell align="center">{data.email}</TableCell>
                                            <TableCell align="center">{data.name}</TableCell>
                                            <TableCell align="center">{data.status ? <span style={{background:"green",padding:"5px",margin:"10px",color:"#fff",borderRadius:"5px"}}>Active</span> : <span style={{background:"red",padding:"5px",margin:"10px",color:"#fff",borderRadius:"5px"}}>InActive</span>}</TableCell>
                                            <TableCell align="center">{data.access_level}</TableCell>
                                            <TableCell align="center">{moment(data.createdAt).format('YYYY-MM-DD')}</TableCell>
                                            <TableCell align="center"><Button variant={'contained'} size='small' color={'warning'} onClick={()=>updateHandle(data)}>Update</Button></TableCell>
                                        </TableRow>
                                    )
                                }
                            </TableBody>
                        </Table>
                    </Box>
                </div>
            </div>

            <Modal
                open={open}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                onBackdropClick={() => setOpen(true)}
            >
                <Box sx={style} spacing={0.5} direction="row" useFlexGap flexWrap="wrap">
                    {/* <h3 style={{textAlign={"c"}}}>Add Sub Admin</h3> */}
                    <Heading margin={"10px"} fontSize={"24px"} fontWeight={"500"} textAlign={"center"}>Add Sub Admin</Heading>

                    <Grid  container spacing={2} mt={1}>
                        <Grid xs={6} item>
                            <label>Name</label><br></br>
                            <TextField style={{ width: "100%", marginTop:"10px" }} id="outlined-basic" type='text' size={'small'} variant="outlined" name={'name'}  value={userAdmin.userState.name} onChange={handleField} />
                        </Grid>
                        <Grid xs={6} item>
                            <label>Email</label><br></br>
                            <TextField style={{ width: "100%",marginTop:"10px" }} id="outlined-basic" type='email' size={'small'} variant="outlined" name={'email'} value={userAdmin.userState.email} autocomplete="off" onChange={handleField} />
                        </Grid>
                        
                        {
                            <Grid xs={6} item>
                            <label>Password</label><br></br>
                            <TextField style={{ width: "100%",marginTop:"10px" }} id="outlined-basic" autocomplete="off"  type='password' size={'small'} variant="outlined" name={'password'} onChange={handleField} />
                        </Grid>
                        }
                        <Grid xs={6} item>
                            <label>Status</label><br></br>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                sx={{marginTop:"10px"}}
                                style={{ width: "100%" }}
                                size={'small'}
                                name='status'
                                value={userAdmin.userState.status}
                                onChange={handleField}
                            >
                                <MenuItem value={true}>Active</MenuItem>
                                <MenuItem value={false}>InActive</MenuItem>
                            </Select>
                        </Grid>
                        <Grid xs={6} item>
                            <label>Access Type</label><br></br>
                            <Select labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                sx={{marginTop:"10px"}}
                                style={{ width: "100%" }}
                                size={'small'}
                                name='access_team'
                                onChange={handleField}
                                value={userAdmin.userState.access_team}
                            >
                                {AccessTeam.map((data) =>
                                    <MenuItem value={data.id}>{data.level_name}</MenuItem>
                                )}
                            </Select>
                        </Grid>
                        <Grid xs={12} item>
                            <label>Access Module</label><br></br>
                            <MultiSelector name={"permissions"} value={userAdmin.userState.permissions || []} handleField={handleField}></MultiSelector>
                        </Grid>
                        <Grid xs={12} item>
                        <Row justifyContent='space-evenly' style={{ marginTop: "15px" }}>
                            <Button color='error' onClick={handleClose} variant="contained">Cancel</Button>
                            <Button variant="contained" onClick={handleSubmit}>Submit</Button>
                        </Row>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </>
    )
}

export default SubAdmin